// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"hawfSMlfH1_WBpJJZPMSb","title":"_1B-Kr4ShJ-ZhnMSEv_elzq","info":"gTVciMcxETPCZGUiqY3CI","label":"fua9RPbHyaqVROMLR2WLR","buttonSection":"_2nOKfxGWkfg0Z7QPKXznZK"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecoveryPlan/components/ResetClock.mod.css
// module id = 1566
// module chunks = 0